import { Unit } from "uom";
// Sound power level
export var DecibelLw = Unit.createBase("DecibelLw", "SoundPowerLevel", "dB");
//# sourceMappingURL=sound-power-level.js.map